import { VideoEndEvent, VideoStartEvent, VideoStateChangeEvent } from './types'
import { bool } from '../../../../utils/utils'
import { isErtDebugMode } from '../../../../utils/localStorageUtils'
import { BaseVideoPlayer } from './plugin/players/BaseVideoPlayer'
import { VideoMirrorEndEvent, VideoMirrorStartEvent } from '@simplisafe/compass-web'

export const getVideoIdentifier = (
  eventPayload: VideoStartEvent | VideoEndEvent | VideoStateChangeEvent | VideoMirrorStartEvent | VideoMirrorEndEvent
): string => {
  return `${eventPayload.cameraId}_${eventPayload.videoPlaceholderName}_${eventPayload.startTimeEpoch}`
}

export const isErtDebugModeEnabled = (): boolean => {
  return bool(import.meta.env.VITE_ENABLE_ERT_DEBUG_MODE) || isErtDebugMode()
}

export function initializeTopLevelDiv(topLevelDiv: HTMLDivElement, video: BaseVideoPlayer) {
  topLevelDiv.style.position = 'relative'
  topLevelDiv.setAttribute('id', video.getVideoIdentifier())
  topLevelDiv.setAttribute('title', video.getVideoIdentifier())
}

export const SCRUBBER_UPDATE_INTERVAL_MS = 200
export const SCRUBBER_UPDATE_ALWAYS_INTERVAL_MS = 3 * SCRUBBER_UPDATE_INTERVAL_MS

export const getEmptySnapshot = (timestamp: number) => ({
  type: 2,
  data: {
    node: {
      type: 0,
      childNodes: [
        {
          type: 2,
          tagName: 'html',
          attributes: {
            lang: 'en'
          },
          childNodes: [
            {
              type: 2,
              tagName: 'body',
              attributes: {
                style: 'background: #000000'
              },
              childNodes: [],
              rootId: 1,
              id: 3
            }
          ],
          rootId: 1,
          id: 2
        }
      ],
      id: 1
    },
    initialOffset: {
      left: 0,
      top: 0
    }
  },
  timestamp
})
